import React from "react";
import styled from "styled-components";

const PrivacyContainer = styled.div`
  max-width: 800px;
  margin: 10px auto;
  padding: 20px;
  font-family: Arial, sans-serif;
  line-height: 1.6;
  color: #333;
  background: #fff;
  font-family: "Poppins", sans-serif;
`;

const Title = styled.h1`
  text-align: start;
  font-size: 2rem;
  margin-bottom: 20px;
  font-family: "Poppins", sans-serif;
`;

const Section = styled.div`
  margin-bottom: 20px;

  ul,
  li {
    list-style: none !important;
    text-align: start;
    padding: 0;
    font-family: "Poppins", sans-serif;
  }
  p {
    text-align: start;
    font-family: "Poppins", sans-serif;
  }
`;

const Subtitle = styled.h2`
  font-size: 1.5rem;
  margin-bottom: 10px;
  color: #444;
  text-align: start;
  font-family: "Poppins", sans-serif;
`;

const PrivacyPolicy = () => {
  return (
    <PrivacyContainer>
      <Title>Privacy Policy</Title>
      <Section>
        <Subtitle>Introduction</Subtitle>
        <p>
          C Template is a free, all-in-one video editor that makes creating
          stunning videos easy and fun. Whether you're a beginner or a pro, C
          Template offers powerful editing tools and a vast library of effects,
          transitions, and music to bring your vision to life.
        </p>
      </Section>
      <Section>
        <Subtitle>Key Features</Subtitle>
        <ul>
          <li>
            ✅ Advanced Video Editing – Cut, trim, merge, reverse, and adjust
            speed with precision.
          </li>
          <li>
            ✅ Trendy Effects & Filters – Apply stylish effects, filters, and
            transitions to make your videos stand out.
          </li>
          <li>
            ✅ Text & Stickers – Add animated text, trendy fonts, and fun
            stickers to personalize your content.
          </li>
          <li>
            ✅ Music & Sound Effects – Choose from a huge library of
            royalty-free music and sound effects.
          </li>
          <li>
            ✅ HD Export & No Watermark – Export your videos in high resolution
            without losing quality.
          </li>
        </ul>
      </Section>
      <Section>
        <Subtitle>Usage</Subtitle>
        <p>
          Perfect for creating social media content, vlogs, reels, and
          professional videos, C Template makes video editing effortless.
          Download now and start editing like a pro! 🚀🎬
        </p>
      </Section>
      <Section>
        <Subtitle>Data Collection & Privacy</Subtitle>
        <p>
          C Template respects your privacy and is committed to protecting your
          personal information. We collect minimal data necessary to enhance
          user experience and ensure seamless functionality.
        </p>{" "}
      </Section>
      <Section>
        <Subtitle>Contact Us</Subtitle>
        <p>
          If you have any questions about this Privacy Policy,
          <br /> You can contact us: By email: <b>forlaunchapps@gmail.com</b>
        </p>
      </Section>
    </PrivacyContainer>
  );
};

export default PrivacyPolicy;
